import React, { ReactNode } from 'react';
import { useFormik } from 'formik';
import moment from 'moment';
import _ from 'lodash';

import {
  Row,
  Col,
  Button,
  Offcanvas,
  Modal,
  Form,
  InputGroup,
  Tabs,
  Tab,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Divider, Radio, Spin, Switch, Checkbox, Tooltip, Tree } from 'antd';
import InputMask from 'react-input-mask';
import DatePicker, { DateObject } from "react-multi-date-picker";
import CurrencyInput from 'react-currency-input-field';

// Auth
// import { useAuthContext } from '../../../auth/use-auth-context.js';
import { useRouter } from '../../../../auth/auth-guard';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { totalFields, fields, FormikContext, initialValues, formSchema, ServiceType, getBillingTypeName, initPricingsItem, getProformaInvoiceStatusList, prepareData } from './slice.tsx';
import jobSlice, { updateBillingPricings, setPricingsData, margePricingsData, checkStatus, getId, isEdit, isCopy, prepareData as jobPrepareData, JobAction } from '../../../jobs/slice.tsx';
import { getFirstCustomerSite, getServiceItemIds } from '../../../manage/jobs/jobTypes/slice.tsx';
import jobFormBinDetailsServicesSlice from '../services/slice.tsx';
import taxRate from "../../../../../v5/utils/slices/taxRate.tsx";
import proformaSlice, { fields as proformaFields, proformaInvoiceStatusText, getTotal, prepareData as prepareDataProforma } from "../proformaInvoice/slice.tsx";
import { StyledTotal } from "../proformaInvoice/Preview.tsx";

import DefaultTaxRatePopup from '../../../services/defaultTaxRate/Form.tsx';
import { getSelectedTaxRate } from '../../../services/slice.tsx';

import SaveServiceForm from './saveService/Form.tsx';
import saveServiceSlice from './saveService/slice.tsx';

import SmartSelect from '../../../../../v5/components/select/SmartSelect.tsx';
import Select from '../../../../../v5/components/select/Select.tsx';

import { info, warning, dateFormat, scrollInElement, getMaxPageSize, getCurrency, formatNumber, isNumeric, downloadPDF } from '../../../../utils/utils.tsx';
import { XeroPaymentTermTypeItems, ProformaInvoiceStatus, AccountMetaType, ProformaPaymentType } from '../../../../utils/enums.tsx';

import { ReactComponent as PlusIcon } from "../../../../../v5/assets/icons/plus.svg";
import { ReactComponent as RefreshIcon } from "../../../../../v5/assets/icons/refresh-new.svg";
import { ReactComponent as TrashIcon } from "../../../../../v5/assets/icons/trash.svg";
import { ReactComponent as CalendarIcon } from "../../../../../v5/assets/icons/calendar.svg";
import { ReactComponent as SettingsIcon } from "../../../../../v5/assets/icons/settings.svg";

// ----------------------------------------------------------------------

export const  StyledTable = styled.table`
  width: 100%;
  
  thead {
    tr {
      th {
        background-color: var(--bs-blue-focus1);
      }
    }
  }

  tbody {
    tr {
      td {
        vertical-align: top;
      }
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 6px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 6px;
    }
  }
`;

export const  StyledDividerVertical = styled(Divider)`
  border-color: var(--bs-gray-300);
  height: 20px;
`;

const StyledA = styled.a`
    svg {
        path {
            stroke: var(--bs-blue-500);
        }
    }

    &:hover {
        svg {
            path {
                stroke: var(--bs-gray-700);
            }
        }
    }
`;


const PageComponent = (props: any) => {
  // const { user }: any = useAuthContext();
  // const { userAccount } = user ?? {};
  // const someField = userAccount?.someField;

  const router = useRouter();

  const { show, form, isLoadingUpdateBilling, tab } = useTypedSelector((state: RootState) => state.jobFormBillingJobSlice);
  const taxRateSlice = useTypedSelector((state: RootState) => state.taxRateSlice);
  const proformaInvoiceSlice = useTypedSelector((state: RootState) => state.jobFormProformaInvoiceSlice);
  const dispatch = useDispatch<AppDispatch>();

  const [count, setCount] = React.useState<any>(1);
  

  React.useEffect(() => {
    if(show){
      let canShowProforma = (!checkStatus(form?.statusName, ['cancelled', 'failed', 'rejected']) && (isEdit() && !isCopy())) ? true : false;
      let hasProforma = (form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? true : false;
      let selectedTab = (canShowProforma && hasProforma) ? 'tab1' : 'tab2';
      dispatch(slice.setTab(selectedTab));

      let isRequirePaymentCollection = (form && (form?.isRequirePaymentCollection === true || form?.isRequirePaymentCollection === false)) ? form?.isRequirePaymentCollection : false;
      let formData = _.cloneDeep(form);
      formData.proformaPaymentType = (isRequirePaymentCollection) ? ProformaPaymentType.CollectedByDriver : ProformaPaymentType.NotCollectedByDriver;
      formData['tab'] = selectedTab;
      setValues(formData);
      
      let customerId = (form && form?.customer) ? form?.customer?.customerId : null;
      if(customerId){
        dispatch(taxRate.getCustomerProfileApi(customerId, (state: boolean, data: any) => {
          dispatch(taxRate.getDefaultTaxRateApi((state: boolean, data: any) => {}));
        }));
      } else {
        dispatch(taxRate.getDefaultProfileApi((state: boolean, data: any) => {
          dispatch(taxRate.getDefaultTaxRateApi((state: boolean, data: any) => {}));
        }));
      }

      router.removeParamFromUrl('profoerma-invoice');
    }
  }, [show, form])

  React.useEffect(() => {        
    setFieldValue('tab', tab);
  }, [tab])

  
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema(),
    onSubmit: values => {
      if(onSave){
        onSave(values);
      }
    },
  });
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = formik;


  React.useEffect(() => {
    if(count > 1){
      let totalObj = getTotal(values, [], 'proformaPricings');
      let balance = totalObj?.balance.toFixed(2);
      setFieldValue('proformaInvoiceTotal', balance);
    }
  }, [count])


  const onCancel = () => {
    dispatch(slice.setShow({ show: false, form: null }));
  }
  const onSave = (values: any) => {
    let data = prepareData(values);
    if(props.onSave){
      props.onSave(data);
    }

    onCancel();
  }
  const onSaveInvoice = (pricings: any) => {
    if(tab === 'tab1'){
      handleSubmit();
      
    } else {
      let state = true;
      if(pricings && pricings.length > 0){
        let arr: Array<any> = [];

        pricings.forEach((x: any, i: number) => {
          if(!isNumeric(x.serviceItemId) && !(x.isSaveAsGlobalService === true || x.isSaveAsLocalService === true)){
            arr.push({
              index: i,
              item: x,
            });
          }
        });

        if(arr && arr.length > 0){
          state = false;
          dispatch(saveServiceSlice.setShow({ show: true, details: arr }));
        }
      }

      if(state){
        handleSubmit();
      }
    }
  }

  
  const onChangeToBillable = () => {
    let additionalsArr = [];
    let canChangeBilling = false;
    if(values && values.pricings && values.pricings.length > 0){
      additionalsArr = values.pricings.filter((x: any) => ((x.serviceType === ServiceType.AdditionalService) && !(x.bundleServiceTag != null && x.bundleServiceTag != '')));
      let pricingsArr = values.pricings.filter((x: any) => !((x.serviceType === ServiceType.AdditionalService) && !(x.bundleServiceTag != null && x.bundleServiceTag != '')));

      canChangeBilling = (pricingsArr && pricingsArr.length > 0) ? false : true;
    } else {
      canChangeBilling = true;
    }
    

    if(canChangeBilling){
      let serviceItemIds: Array<any> = getServiceItemIds(values);

      if(additionalsArr && additionalsArr.length > 0){
        additionalsArr.forEach((itm: any) => {
          if(serviceItemIds.findIndex((x: any) => x.serviceItemId === itm.serviceItemId) < 0){
            serviceItemIds.push({
              serviceItemId: itm.serviceItemId,
              quantity: itm.quantity || 1,
              order: itm.order || 0,
            });
          }
        });
      }

      if(serviceItemIds && serviceItemIds.length > 0 ){
        dispatch(jobFormBinDetailsServicesSlice.callDetailsServicesItemsApi(serviceItemIds.map((x) => x.serviceItemId), async (state: boolean, selectedServices: any) => {
          if(state){
            let arr = selectedServices.map((y: any) => {
              let quantity = serviceItemIds.find((x) => x.serviceItemId === y.serviceItemId)?.quantity || 0;

              return {
                ...y,
                binTypeName: y?.binType?.binTypeName,
                wasteTypeName: y?.wasteType?.wasteTypeName,
                quantity: quantity,
              }
            });
  
            let pricings: Array<any> = [];
            if(arr && arr.length > 0){
              arr.forEach((mainItem: any) => {
                let order = serviceItemIds.find((x) => x.serviceItemId === mainItem.serviceItemId)?.order || 0;
                let newPricings = setPricingsData(mainItem, [], order, false);
                pricings = margePricingsData(pricings, newPricings);
              });
            }
            
            await setFieldValue('pricings', pricings);
          }
        }));
      }
    }
  }

  const isInvalid = () => {
    return (errors && Object.entries(errors).length > 0)
  }

  const generate = () => {
    dispatch(slice.setLoading(true));

    let data = jobPrepareData(form, JobAction.Save, null);
    data['generateProformaInvoice'] = true;
    dispatch(jobSlice.callUpdateApi(data, (state: boolean, data: any) => {
      if(state){
        router.reloadWithParam('profoerma-invoice', 'true');
      }

      dispatch(slice.setLoading(false));
    }));
  }
  const download = () => {
    info('Download', 'Please Wait ...');

    let data = prepareDataProforma(values);
    dispatch(proformaSlice.callGetJobDocApi(data, (state: boolean, data: any) => {
      if(state){
        let fileName = form?.jobNumber + '-' +form?.customer?.billingName  + ".pdf"
        downloadPDF(fileName, data);
      }
    }));
  }
  const print = () => {
    let data = prepareDataProforma(values);
    data['isProformaInvoice'] = true;

    localStorage.setItem("jobIframeData", JSON.stringify(data));

    const link = document.createElement("a");
    link.href = "/Job-Iframe";
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  const convertToInvoice = () => {
    let pricings: Array<any> = [];

    let proformaPricings = (values && values.proformaPricings && values.proformaPricings.length > 0) ? _.cloneDeep(values.proformaPricings) : [];
    if(proformaPricings && proformaPricings.length > 0){
      proformaPricings.forEach((item: any) => {
        delete item.jobProformaPricingId;
        pricings.push(item);
      });

      setFieldValue('pricings', pricings);
      setFieldValue('isBillable', true);

      dispatch(slice.setTab('tab2'));
    }
  }
  

  const footerElements = () => {
    let field = (tab === 'tab1') ? 'proformaPricings' : 'pricings';

    let totalObj = getTotal(values, [], field);
    let subtotal = totalObj?.subtotal;
    let totalGST = totalObj?.totalGST;
    let total = totalObj?.total;
    let paymentReceived = totalObj?.paymentReceived;
    let balance = totalObj?.balance;
            
    return <Row className='w-100 gx-12 align-items-center'>
      <Col xs={true}></Col>

      {((tab === 'tab1') || (tab === 'tab2' && values.isBillable)) && <Col xs={'auto'} className='text-end'>
        <span className='gray-700'>{totalFields.subtotal.label}: {getCurrency() + formatNumber(subtotal)}</span>
        <StyledDividerVertical type='vertical' />
        <span className='gray-700'>{totalFields.GSTTotal.label}: {getCurrency() + formatNumber(totalGST)}</span>
        <StyledDividerVertical type='vertical' className='d-none d-sm-inline-block' />
        <div className='d-block d-sm-none'></div>
        <span className='gray-900 semibold'>{totalFields.total.label}: {getCurrency() + formatNumber(total)}</span>
        
        {(values && values?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') && <>
          <StyledDividerVertical type='vertical' className='d-none d-sm-inline-block' />
          <span className='gray-700'>{totalFields.paymentReceived.label}: {getCurrency() + formatNumber(paymentReceived)}</span>
          <StyledDividerVertical type='vertical' className='d-none d-sm-inline-block' />
          <span className='gray-900 semibold'>{totalFields.balance.label}: {getCurrency() + formatNumber(balance)}</span>
        </>}
      </Col>}
      
      <Col xs={'auto'} className='text-end'>
        <Button
          variant={'custom-text'}
          size={'sm'}
          className='me-12'
          onClick={(e) => {
            onCancel();
          }}
        >Cancel</Button>
        <Button
          variant={'custom-primary'}
          size={'sm'}
          disabled={isInvalid()}
          onClick={(e) => {
            onSaveInvoice(values?.pricings)
          }}
        >Ok</Button>
      </Col>
    </Row>
  }

  const formElements = () => {
    let canShowProforma = (!checkStatus(values?.statusName, ['cancelled', 'failed', 'rejected']) && (isEdit() && !isCopy())) ? true : false;
    let hasProforma = (values && values?.proformaInvoiceNumber && values?.proformaInvoiceNumber != '') ? true : false;

    return <Row className='g-32 align-items-center'>
      <Col xs={12}>
        <Row className='gx-40 gy-16 align-items-center'>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label disabled={true}>{fields.jobNumber.label}</Form.Label>
              <Form.Control
                type={'text'}
                autoComplete='off'
                size={'sm'}
                placeholder={fields.jobNumber.placeholder}
                disabled={true}
                value={values?.jobNumber}
                onChange={(e) => {
                  setFieldValue('jobNumber', e.target.value);
                }}
                isInvalid={!!(errors && errors.jobNumber)}
              />
              <Form.Control.Feedback type="invalid">{errors && errors.jobNumber as ReactNode}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label disabled={true}>{fields.customerName.label}</Form.Label>
              <Form.Control
                type={'text'}
                autoComplete='off'
                size={'sm'}
                placeholder={fields.customerName.placeholder}
                disabled={true}
                value={values?.customerName}
                onChange={(e) => {
                  setFieldValue('customerName', e.target.value);
                }}
                isInvalid={!!(errors && errors.customerName)}
              />
              <Form.Control.Feedback type="invalid">{errors && errors.customerName as ReactNode}</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group>
              <Form.Label>{fields.isBillable.label}</Form.Label>
              <div>
                <Radio
                  name={'jobform_billable'}
                  checked={values.isBillable}
                  onChange={(e) => {
                    setFieldValue('isBillable', true);

                    dispatch(slice.setTab('tab2'));

                    onChangeToBillable();
                  }}
                >{fields.isBillable.optionBillable}</Radio>
                <Radio
                  name={'jobform_billable'}
                  checked={!values.isBillable}
                  onChange={(e) => {
                    setFieldValue('isBillable', false);

                    if(canShowProforma && hasProforma){
                      dispatch(slice.setTab('tab1'));
                    }
                  }}
                >{fields.isBillable.optionNonBillable}</Radio>
              </div>
              <Form.Control.Feedback type="invalid">{errors && errors.isBillable as ReactNode}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Col>

      <Col xs={12}>
        <Row className='gx-40 gy-16 align-items-center'>
          {canShowProforma && <Col xs={12}><Divider className='m-0' /></Col>}
          
          {(canShowProforma && !hasProforma) && <Col xs={12}>
            <Button
              variant={'custom-outlined'}
              size={'sm'}
              onClick={(e) => {
                generate();
              }}
            >Generate Proforma</Button>
          </Col>}
          
          <Col xs={12}>
            <Tabs
              activeKey={tab}
              onSelect={(eventKey: any) => {
                dispatch(slice.setTab(eventKey));
              }}
            >
              {(canShowProforma && hasProforma) && <Tab eventKey={'tab1'} title={'Proforma'} disabled={false} />}
              {values.isBillable && <Tab eventKey={'tab2'} title={'Invoice'} disabled={false} />}
            </Tabs>
          </Col>

          {((canShowProforma && hasProforma) && (tab === 'tab1')) && <Col xs={12}>{proformaElements()}</Col>}
          {(values.isBillable && (tab === 'tab2')) && <Col xs={12}>{invoiceElements()}</Col>}
        </Row>
      </Col>
    </Row>
  }

  const invoiceElements = () => {
    // let totalObj = getTotal(values);
    // let subtotal = totalObj?.subtotal;
    // let totalGST = totalObj?.totalGST;
    // let total = totalObj?.total;

    return <>
      {values.isBillable && <Row className='g-24 align-items-center'>
        {/* <Col xs={12}><Divider className='m-0' /></Col> */}

        <Col xs={12} className='fs-16 semibold gray-900'>Invoice</Col>
        <Col xs={12} className='mt-8'>
          <Row className='gx-40 gy-16 align-items-center'>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.accountBillingProfileId.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  size={'sm'}
                  placeholder={fields.accountBillingProfileId.placeholder}
                  disabled={true}
                  value={values.customer?.billingProfileName || ''}
                  onChange={async (e) => {
                    
                  }}
                  isInvalid={false}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.billingAddress.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  size={'sm'}
                  placeholder={fields.billingAddress.placeholder}
                  disabled={true}
                  value={values.customer?.billingAddress || ''}
                  onChange={(e) => {
                  }}
                  isInvalid={false}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label>{fields.invoiceDate.label}</Form.Label>
                <InputGroup>
                  <Form.Control
                    as = {InputMask}
                    mask={'99-99-9999'}
                    maskChar={null}
                    placeholder={dateFormat()}
                    value={values?.invoiceDate}
                    onChange={(e) => {
                      setFieldValue('invoiceDate', e.target.value);
                    }}
                    isInvalid={!!(errors && errors.invoiceDate)}
                  />
                  <InputGroup.Text>
                    <DatePicker
                      portal={true}
                      onOpenPickNewDate={false}
                      shadow={false}
                      disabled={false}
                      calendarPosition={'bottom-right'} 
                      format={dateFormat()}
                      value={values?.invoiceDate}
                      onChange={(value: DateObject) => {
                        setFieldValue('invoiceDate', value.format(dateFormat()));
                      }}
                      render={(value, openCalendar) => {
                        return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                      }}
                    />
                  </InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">{errors && errors.invoiceDate as ReactNode}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            {values.customer?.billingProfile?.isConnectQuickbook && <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.paymentTermsId.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  placeholder={fields.paymentTermsId.placeholder}
                  disabled={true}
                  value={values.customer?.paymentTerms || ''}
                  onChange={async (e) => {
                    
                  }}
                  isInvalid={false}
                />
              </Form.Group>
            </Col>}

            {values.customer?.billingProfile?.isConnectXero && <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.xeroPaymentTerm.label}</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={'text'}
                    autoComplete='off'
                    placeholder={fields.xeroPaymentTerm.placeholder}
                    disabled={true}
                    value={values.customer?.xeroPaymentTerm || ''}
                    onChange={async (e) => {
                      
                    }}
                    isInvalid={false}
                  />
                  <InputGroup.Text>{XeroPaymentTermTypeItems.find((x: any) => x.value == (values.customer?.xeroPaymentTermType || ''))?.title || ''}</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>}
          
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label>{fields.billingNote.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  size={'sm'}
                  placeholder={fields.billingNote.placeholder}
                  disabled={false}
                  value={values?.billingNote || ''}
                  onChange={(e) => {
                    setFieldValue('billingNote', e.target.value);
                  }}
                  isInvalid={!!(errors && errors.billingNote)}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.billingNote as ReactNode}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.invoiceNumber.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  size={'sm'}
                  placeholder={fields.invoiceNumber.placeholder}
                  disabled={true}
                  value={''}
                  onChange={(e) => {
                    
                  }}
                  isInvalid={false}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
        
        <Col xs={12}><Divider className='m-0' /></Col>

        <Col xs={12}>
          <Row className='g-12 align-items-center'>
            <Col xs={true} className='fs-16 semibold gray-900'>Services</Col>
            {values?.isBillable && <Col xs={'auto'} className='text-end'>
              <Button
                variant={'custom-outlined'}
                size={'sm'}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  
                  let customerSites = getFirstCustomerSite(values);
                  dispatch(slice.callUpdateBillingApi({ customerId: values?.customerId, customerSiteId: customerSites?.customerSiteId }, async (state: boolean, data: any) => {
                    if(state){
                      let arr = (data && data.data && data.data.length > 0) ? data.data : [];
                      let pricingsArr: Array<any> = updateBillingPricings(values, arr);
                      await setFieldValue('pricings', pricingsArr);
                    }
                  }));
                }}
              >
                <RefreshIcon />
                <span className='ms-s4'>Update Billing</span>
              </Button>
            </Col>}
          </Row>
        </Col>

        <Col xs={12}>{tableElements()}</Col>
      </Row>}
    </>
  }

  const proformaElements = () => {
    let totalObj = getTotal(values, [], 'proformaPricings');
    // let subtotal = totalObj?.subtotal;
    // let totalGST = totalObj?.totalGST;
    let total = totalObj?.total;

    let selectedTaxRate = getSelectedTaxRate(null, taxRateSlice);

    return <Row className='g-24 align-items-center'>
      
      {(values && values?.proformaInvoiceNumber && values?.proformaInvoiceNumber != '') && <>
        <Col xs={12}>
          <Row className='gx-40 gy-16'>
            <Col xs={12} md={4} lg={3}>
              <Form.Group>
                <Form.Label>{fields.proformaInvoiceDate.label}</Form.Label>
                <InputGroup>
                  <Form.Control
                    as = {InputMask}
                    mask={'99-99-9999'}
                    maskChar={null}
                    placeholder={dateFormat()}
                    value={values?.proformaInvoiceDate}
                    onChange={(e) => {
                      setFieldValue('proformaInvoiceDate', e.target.value);
                    }}
                    isInvalid={!!(errors && errors.proformaInvoiceDate)}
                  />
                  <InputGroup.Text>
                    <DatePicker
                      portal={true}
                      onOpenPickNewDate={false}
                      shadow={false}
                      disabled={false}
                      calendarPosition={'bottom-right'} 
                      format={dateFormat()}
                      value={values?.proformaInvoiceDate}
                      onChange={(value: DateObject) => {
                        setFieldValue('proformaInvoiceDate', value.format(dateFormat()));
                      }}
                      render={(value, openCalendar) => {
                        return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                      }}
                    />
                  </InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">{errors && errors.proformaInvoiceDate as ReactNode}</Form.Control.Feedback>
                {(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Paid) && <div className='fs-11 mt-s2 text-success'>&nbsp;</div>}
              </Form.Group>
            </Col>
          
            <Col xs={12} md={4} lg={3}>
              <Form.Group>
                <Form.Label disabled={true}>{fields.proformaInvoiceNumber.label}</Form.Label>
                <Form.Control
                  type={'text'}
                  autoComplete='off'
                  size={'sm'}
                  placeholder={fields.proformaInvoiceNumber.placeholder}
                  disabled={true}
                  value={values?.proformaInvoiceNumber}
                  onChange={(e) => {
                    setFieldValue('proformaInvoiceNumber', e.target.value);
                  }}
                  isInvalid={!!(errors && errors.proformaInvoiceNumber)}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.proformaInvoiceNumber as ReactNode}</Form.Control.Feedback>
                {(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Paid) && <div className='fs-11 mt-s2 text-success'>&nbsp;</div>}
              </Form.Group>
            </Col>
            
            <Col xs={12} md={4} lg={3}>
              <Form.Group>
                <Form.Label>{fields.proformaInvoiceStatus.label}</Form.Label>
                <Form.Control
                  as={Select}
                  value={values.proformaInvoiceStatus}
                  placeholder={'Select'}
                  searchable={false}
                  allowClear={true}
                  selectedIcon={true}
                  loading={false}
                  disabled={false}
                  onChangeValue={(value: any, option: any, ref: any) => {
                    setFieldValue('proformaInvoiceStatus', value);
                  }}
                  labelRender={(props: any) => {
                    return <span className={getProformaInvoiceStatusList(values, true).find((x: any) => x.value === props.value)?.className}>{props?.label}</span>
                  }}
                  options={getProformaInvoiceStatusList(values, true)}
                  optionRender={(option: any, ref: any) => {
                    return <span className={option?.data?.className}>{option.label}</span>
                  }}
                  isInvalid={!!(errors && errors.proformaInvoiceStatus)}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.proformaInvoiceStatus as ReactNode}</Form.Control.Feedback>
                {(values?.proformaInvoiceStatus === ProformaInvoiceStatus.Paid) && <div className='fs-11 mt-s2 text-success'>{proformaInvoiceStatusText(values?.proformaInvoiceStatus, total, values?.proformaPaymentReceived)}</div>}
              </Form.Group>
            </Col>

            <Col xs={12} md={4} lg={3} className='d-none d-lg-block'></Col>

            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>{proformaFields.proformaInvoiceTotal.label}</Form.Label>
                <Form.Control
                  as={CurrencyInput}
                  allowDecimals={true}
                  allowNegativeValue={true}
                  prefix={getCurrency()}
                  decimalsLimit={2}
      
                  autoComplete='off'
                  placeholder={proformaFields.proformaInvoiceTotal.placeholder}
                  disabled={false}
                  value={values.proformaInvoiceTotal}
                  onValueChange={(value: any) => {
                    setFieldValue('proformaInvoiceTotal', value);
                  }}
                  isInvalid={!!(errors && errors.proformaInvoiceTotal)}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.proformaInvoiceTotal as ReactNode}</Form.Control.Feedback>
              </Form.Group>

              <Row className='g-8 align-items-center mt-s2'>
                <Col xs={'auto'}>
                  {
                    taxRateSlice.isConnected
                    ?
                    <>
                      <Tooltip title={'Company settings'} className={'dark-tooltip mb-3'}>
                        <StyledA href={taxRateSlice.accountBillingProfileId ? '/manage/profile/company?id=' + taxRateSlice.accountBillingProfileId + '&selectedTab=1' : '/manage/profiles'}
                          target={'_blank'}
                          rel="noopener noreferrer"
                        >
                          <SettingsIcon />
                        </StyledA>
                      </Tooltip>
                    </>
                    :
                    <>
                      <Tooltip title={'Set default tax rate'} className={'dark-tooltip mb-3'}>
                        <DefaultTaxRatePopup />
                      </Tooltip>
                    </>
                  }
                </Col>
                {(isNumeric(values.proformaInvoiceTotal) && isNumeric(selectedTaxRate) && (!taxRateSlice.isLoading)) && <Col xs={'auto'}>
                  <div className='mt-s2'>Tax rate is {selectedTaxRate}%</div>
                </Col>}
              </Row>
            </Col>
            
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>{proformaFields.proformaPaymentMethodMetaId.label}</Form.Label>
                <Form.Control
                  as={SmartSelect}
                  isInvalid={!!(errors && errors.proformaPaymentMethodMetaId)}
                  value={values.proformaPaymentMethodMetaId}
                  placeholder={proformaFields.proformaPaymentMethodMetaId.placeholder}
                  addText={'Add new payment method'}
                  apiPath={'accountMeta'}
                  customParams={{
                    types: AccountMetaType.PaymentMethod.toString(),
                  }}
                  readResponseFunc={(options: any) => {
                    return (options && options.length > 0) ? options : [];
                  }}
                  fieldNames={{ value: 'accountMetaId', label: 'value' }}
                  selected={{ accountMetaId: values.proformaPaymentMethodMetaId, value: values.proformaPaymentMethodMetaName }}
                  hasOptionRender={false}
                  hasFooterRender={false}
                  searchable={false}
                  allowClear={true}
                  selectedIcon={false}
                  disabled={false}
                  loading={false}
                  virtual={true}
                  onChangeValue={async (value: any, option: any, ref: any) => {
                    if(option){
                      await setFieldValue('proformaPaymentMethodMetaId', value);
                      await setFieldValue('proformaPaymentMethodMetaName', option.value);
                    } else {
                      await setFieldValue('proformaPaymentMethodMetaId', null);
                      await setFieldValue('proformaPaymentMethodMetaName', '');
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.proformaPaymentMethodMetaId as ReactNode}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>{proformaFields.proformaPaymentType.label}</Form.Label>
                <Form.Group as={Row} className='checkbox-field sm align-items-center w-100 g-0'
                  onClick={(e: any) => {
                    e.stopPropagation();
                    e.preventDefault();

                    if(values.proformaPaymentType == ProformaPaymentType.CollectedByDriver){
                      setFieldValue('proformaPaymentType', ProformaPaymentType.NotCollectedByDriver);
                    } else {
                      setFieldValue('proformaPaymentType', ProformaPaymentType.CollectedByDriver);
                    }
                  }}
                >
                  <Col xs={true} className='m-0'>{proformaFields.proformaPaymentType.label}</Col>
                  <Col xs={'auto'}>
                    <Switch
                      checked={(values.proformaPaymentType == ProformaPaymentType.CollectedByDriver)}
                      onChange={(checked) => {
                        if(checked){
                          setFieldValue('proformaPaymentType', ProformaPaymentType.CollectedByDriver);
                        } else {
                          setFieldValue('proformaPaymentType', ProformaPaymentType.NotCollectedByDriver);
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Form.Group>
            </Col>
            
            <Col xs={12} md={3}>
              <Form.Group>
                <Form.Label>{proformaFields.proformaPaymentReceived.label}</Form.Label>
                <Form.Control
                  as={CurrencyInput}
                  allowDecimals={true}
                  allowNegativeValue={false}
                  prefix={getCurrency()}
                  decimalsLimit={2}
      
                  autoComplete='off'
                  placeholder={proformaFields.proformaPaymentReceived.placeholder}
                  disabled={false}
                  value={values.proformaPaymentReceived}
                  onValueChange={async (value: any) => {
                    await setFieldValue('proformaPaymentReceived', value);

                    setCount(count+1);
                  }}
                  isInvalid={!!(errors && errors.proformaPaymentReceived)}
                />
                <Form.Control.Feedback type="invalid">{errors && errors.proformaPaymentReceived as ReactNode}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </>}
      
      <Col xs={12}><Divider className='m-0' /></Col>

      <Col xs={12}>
        <Row className='g-12 align-items-center'>
          <Col xs={true} className='fs-16 semibold gray-900'>Services</Col>
          <Col xs={'auto'}>
            <Button
              variant={'custom-outlined'}
              size={'sm'}
              onClick={(e) => {
                let customer = (values && values.customer) ? values?.customer : null;
                let accountBillingProfileId = (customer && customer.accountBillingProfileId) ? customer?.accountBillingProfileId : null;
                router.open('/manage/profile/company?id=' + accountBillingProfileId + '&selectedTab=7');
              }}
            >Proforma Setting</Button>
          </Col>
          <Col xs={'auto'}>
            <Divider type="vertical" className='mx-0' style={{ height: '25px' }} />
          </Col>
          <Col xs={'auto'}>
            <Button
              variant={'custom-outlined'}
              size={'sm'}
              onClick={(e) => {
                dispatch(proformaSlice.setShow({ show: true, form: values }));
              }}
            >Send Email</Button>
          </Col>
          <Col xs={'auto'}>
            <Button
              variant={'custom-outlined'}
              size={'sm'}
              onClick={(e) => {
                print();
              }}
            >Print</Button>
          </Col>
          <Col xs={'auto'}>
            <Button
              variant={'custom-outlined'}
              size={'sm'}
              onClick={(e) => {
                download();
              }}
            >Download</Button>
          </Col>
          <Col xs={'auto'}>
            <Button
              variant={'custom-primary'}
              size={'sm'}
              disabled={isInvalid()}
              onClick={(e) => {
                convertToInvoice();
              }}
            >Convert to Invoice</Button>
          </Col>
        </Row>
      </Col>
      
      <Col xs={12}>{tableElements()}</Col>

    </Row>
  }

  const tableElements = () => {
    let field = (tab === 'tab1') ? 'proformaPricings' : 'pricings';

    let totalObj = getTotal(values, [], field);
    let subtotal = totalObj?.subtotal;
    let totalGST = totalObj?.totalGST;
    let total = totalObj?.total;
    let paymentReceived = totalObj?.paymentReceived;
    let balance = totalObj?.balance;
    
    let pricings = (values && values[field] && values[field].length > 0) ? values[field] : [];

    return <Row className='gx-40 gy-16 align-items-center'>
      <Col xs={12}>
        <StyledTable className=''>
          <thead>
            <tr>
              <th style={{ width: '25%' }}>{fields.serviceTag.label}</th>
              <th style={{ width: '20%' }}>{fields.billingType.label}</th>
              <th style={{ width: '20%' }}>{fields.chargeCategoryId.label}</th>
              <th style={{ width: '10%' }}>{fields.quantity.label}</th>
              <th style={{ width: '10%' }}>{fields.price.label}</th>
              <th style={{ width: '10%' }}>{fields.total.label}</th>
              <th style={{ width: '5%' }}>{fields.delete.label}</th>
            </tr>
          </thead>
          <tbody>
            {
              (pricings && pricings.length > 0)
              ?
              pricings.map((item: any, i: number) => {
                return <tr key={'jobform_billing_item_' + tab + '_' + i} className={'jobform-billing-item-' + i}>
                  <td>
                    {
                      (item.serviceType === ServiceType.AdditionalService)
                      ?
                        <Form.Group>
                          <Form.Control
                            as={SmartSelect}
                            isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].serviceTag)}
                            value={item.serviceItemId}
                            placeholder={fields.serviceTag.placeholder}

                            addText={'Add new service item'}
                            apiPath={'service-item'}
                            customParams={{
                              type: ServiceType.AdditionalService,
                              customerId: values?.customerId,
                              customerSiteId: values?.customerSiteId,
                              includeGlobalService: true,
                              IncludeTaxRate: true,
                              sortColumn: 'serviceTag',
                              sortDir: 'desc'
                            }}
                            fieldNames={{ value: 'serviceItemId', label: 'serviceTag' }}
                            selected={{ serviceItemId: item.serviceItemId, serviceTag: item.serviceTag }}

                            hasOptionRender={false}
                            hasFooterRender={false}
                            searchable={true}
                            allowClear={true}
                            selectedIcon={false}
                            disabled={false}
                            virtual={true}

                            onChangeValue={async (value: any, option: any, ref: any) => {
                              if(option){
                                await setFieldValue(field + '.' + i + '.serviceItemId', value);
                                await setFieldValue(field + '.' + i + '.serviceTag', option.serviceTag);
                                await setFieldValue(field + '.' + i + '.serviceItem', option);

                                let chargeCategory = (option && option.chargeCategory) ? option.chargeCategory : null;
                                let chargeCategoryId = (chargeCategory && chargeCategory.chargeCategoryId) ? chargeCategory.chargeCategoryId : null;
                                let chargeCategoryName = (chargeCategory && chargeCategory.chargeCategoryName) ? chargeCategory.chargeCategoryName : '';

                                if (chargeCategory) {
                                  await setFieldValue(field + '.' + i + '.chargeCategoryId', chargeCategoryId);
                                  await setFieldValue(field + '.' + i + '.chargeCategoryName', chargeCategoryName);
                                  await setFieldValue(field + '.' + i + '.chargeCategory', chargeCategory);
                                }


                                let billingType = option ? option.billingType : null;
                                if(billingType){
                                  await setFieldValue(field + '.' + i + '.billingType', billingType);
                                }
                                
                                let price = option ? option.price : '0';
                                await setFieldValue(field + '.' + i + '.price', price);
                                await setFieldValue(field + '.' + i + '.quantity', 1);
                                await setFieldValue(field + '.' + i + '.bundleServiceTag', '');

                                setCount(count+1);
                              } else {
                                await setFieldValue(field + '.' + i + '.serviceItemId', null);
                                await setFieldValue(field + '.' + i + '.serviceTag', '');
                                await setFieldValue(field + '.' + i + '.serviceItem', null);

                                await setFieldValue(field + '.' + i + '.bundleServiceTag', '');
                                await setFieldValue(field + '.' + i + '.billingType', null);

                                await setFieldValue(field + '.' + i + '.price', '');
                                await setFieldValue(field + '.' + i + '.quantity', '');

                                await setFieldValue(field + '.' + i + '.chargeCategoryId', null);
                                await setFieldValue(field + '.' + i + '.chargeCategoryName', '');
                                await setFieldValue(field + '.' + i + '.chargeCategory', null);

                                setCount(count+1);
                              }
                            }}
                          />
                          <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].serviceTag) && errors[field][i].serviceTag}</Form.Control.Feedback>
                          {item.useBinWeightQuantity && <Form.Control.Feedback type="invalid" className={'d-block'}>{(errors && errors[field] && typeof errors[field] === 'string') && errors[field] as ReactNode}</Form.Control.Feedback>}
                        </Form.Group>
                      :
                        <Form.Group>
                          <Form.Control
                            type={'text'}
                            autoComplete='off'
                            size={'sm'}
                            placeholder={fields.serviceTag.placeholder}
                            disabled={false}
                            value={item.serviceTag}
                            onChange={async (e) => {
                              await setFieldValue(field + '.' + i + '.serviceTag', e.target.value);
                              await setFieldValue(field + '.' + i + '.bundleServiceTag', e.target.value);
                            }}
                            isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].serviceTag)}
                          />
                          <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].serviceTag) && errors[field][i].serviceTag}</Form.Control.Feedback>
                          {item.useBinWeightQuantity && <Form.Control.Feedback type="invalid" className={'d-block'}>{(errors && errors[field] && typeof errors[field] === 'string') && errors[field] as ReactNode}</Form.Control.Feedback>}
                        </Form.Group>
                    }
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        size={'sm'}
                        placeholder={fields.billingType.placeholder}
                        disabled={true}
                        value={getBillingTypeName(item.billingType)}
                        onChange={(e) => {
                          setFieldValue(field + '.' + i + '.billingType', e.target.value);
                        }}
                        isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].billingType)}
                      />
                      <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].billingType) && errors[field][i].billingType}</Form.Control.Feedback>
                    </Form.Group>
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Control
                        as={SmartSelect}
                        isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].chargeCategoryId)}
                        value={item.chargeCategoryId}
                        placeholder={fields.chargeCategoryId.placeholder}

                        addText={'Add new category'}
                        apiPath={'chargecategory'}
                        customParams={{
                          currentPage: 1,
                          pageSize: getMaxPageSize(),
                          searchQuery: '',
                          isActive: true,
                        }}
                        fieldNames={{ value: 'chargeCategoryId', label: 'chargeCategoryName' }}
                        selected={{ chargeCategoryId: item.chargeCategoryId, chargeCategoryName: item?.chargeCategory?.chargeCategoryName }}

                        hasOptionRender={false}
                        hasFooterRender={false}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        disabled={isNumeric(item.serviceItemId) && isNumeric(item.chargeCategoryId)}
                        virtual={true}

                        onChangeValue={async (value: any, option: any, ref: any) => {
                          if(option){
                            await setFieldValue(field + '.' + i + '.chargeCategoryId', value);
                            await setFieldValue(field + '.' + i + '.chargeCategoryName', option.chargeCategoryName);
                            await setFieldValue(field + '.' + i + '.chargeCategory', option);
                                                              
                            let invoiceTaxRate = option?.invoiceTaxRate;
                            let purchaseTaxRate = option?.purchaseTaxRate;
                            dispatch(taxRate.setTaxRate({ index: value, invoiceTaxRate: invoiceTaxRate, purchaseTaxRate: purchaseTaxRate }));
                          } else {
                            await setFieldValue(field + '.' + i + '.chargeCategoryId', null);
                            await setFieldValue(field + '.' + i + '.chargeCategoryName', '');
                            await setFieldValue(field + '.' + i + '.chargeCategory', null);
                            
                            dispatch(taxRate.setTaxRate({ index: null, invoiceTaxRate: null, purchaseTaxRate: null }));
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].chargeCategoryId) && errors[field][i].chargeCategoryId}</Form.Control.Feedback>
                      {item.useBinWeightQuantity && <div className='fs-11 gray-600'><i>Bin Weight is Linked as Quantity</i></div>}
                    </Form.Group>
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Control
                        as={CurrencyInput}
                        allowDecimals={true}
                        allowNegativeValue={false}
                        decimalsLimit={2}
      
                        autoComplete='off'
                        // disabled={isMainPriceUseBinWeightQuantity(values[field], item)}
                        disabled={(item.useBinWeightQuantity == true)}
                        placeholder={fields.quantity.placeholder}
                        value={item.quantity}
                        onValueChange={async (value: any) => {
                          await setFieldValue(field + '.' + i + '.quantity', value);

                          setCount(count+1);
                        }}
                      
                        isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].quantity)}
                      />
                      <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].quantity) && errors[field][i].quantity}</Form.Control.Feedback>
                    </Form.Group>
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Control
                        as = {CurrencyInput}
                        isInvalid={!!(errors && errors[field] && errors[field][i] && errors[field][i].price)}
                        
                        allowDecimals={true}
                        allowNegativeValue={true}
                        disableGroupSeparators={true}
                        prefix={getCurrency()}

                        placeholder={fields.price.placeholder}
                        value={item.price}
                        onValueChange={async (value: any) => {
                          await setFieldValue(field + '.' + i + '.price', value);

                          setCount(count+1);
                        }}
                      />
                      <Form.Control.Feedback type="invalid">{(errors && errors[field] && errors[field][i] && errors[field][i].price) && errors[field][i].price}</Form.Control.Feedback>
                      <Form.Control.Feedback type="invalid" className={(item.isTaxInclusive && isNumeric(item.price)) ? 'd-block' : ''}>{taxRate.getTaxRate(item.isTaxInclusive, item, { invoiceTaxRate: taxRateSlice?.invoiceTaxRate, purchaseTaxRate: taxRateSlice?.purchaseTaxRate, category: taxRateSlice?.category, isConnected: taxRateSlice?.isConnected, defaultTaxRate: taxRateSlice?.defaultTaxRate })}</Form.Control.Feedback>
                    </Form.Group>
                  </td>
                  <td>
                    <div className='mt-8'>{getCurrency()}{formatNumber(item.quantity * item.price)}</div>
                  </td>
                  <td>
                    <Button
                      className='p-1'
                      variant={'custom-secondary-danger'}
                      size={'sm'}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();

                        let items = _.cloneDeep(values[field]);
                        items.splice(i, 1);
                        setFieldValue(field, items);

                        setCount(count+1);
                      }}
                    >
                      <TrashIcon style={{ width: '18px', height: '18px' }} />
                    </Button>
                  </td>
                </tr>
              })
              :
              <tr>
                <td colSpan={7} className='text-center'>No pricings</td>
              </tr>
            }
          </tbody>
        </StyledTable>
      </Col>

      <Col xs={12} className='mb-32'>
        <Row>
          <Col xs={{ span: 12, order: 2 }} md={{ span: true, order: 1 }}>
            <Button 
              variant={'custom-secondary'}
              size={'sm'}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                validateForm().then((err: any) => {
                  if (err && Object.entries(err).length > 0) {
                    warning('Warning', 'You must fill in the required fields');
                  } else {
                    let items = (values[field] && values[field].length > 0) ? _.cloneDeep(values[field]) : [];
                    let newItem = _.cloneDeep(initPricingsItem);
                    items.push(newItem);
                    
                    setFieldValue(field, items);

                    setCount(count+1);

                    setTimeout(() => {
                      scrollInElement('.scrollable-container', '.jobform-billing-item-' + (items.length-1));
                    }, 100);
                  }
                })
              }}
            >
              <PlusIcon />
              <span className='ps-s4'>Add Service Items</span>
            </Button>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={{ span: 'auto', order: 2 }}>
            <StyledTotal className='gx-0 mt-s1'>
              <Col xs={12}>
                <Row>
                  <Col xs={6} md={4} lg={5} className='fs-14 regular gray-900'>{totalFields.subtotal.label}</Col>
                  <Col xs={6} md={8} lg={7} className='fs-14 regular gray-900'>{getCurrency() + formatNumber(subtotal)}</Col>
                </Row>
              </Col>
              <Col xs={12}>
                <Row>
                  <Col xs={6} md={4} lg={5} className='fs-14 regular gray-900'>{totalFields.GSTTotal.label}</Col>
                  <Col xs={6} md={8} lg={7} className='fs-14 regular gray-900'>{getCurrency() + formatNumber(totalGST)}</Col>
                </Row>
              </Col>
              <Col xs={12}>
                <Row>
                  <Col xs={6} md={4} lg={5} className='fs-14 semibold gray-900'>{totalFields.total.label}</Col>
                  <Col xs={6} md={8} lg={7} className='fs-14 semibold gray-900'>{getCurrency() + formatNumber(total)}</Col>
                </Row>
              </Col>
            </StyledTotal>

            {(values && values?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') && <>
              <StyledTotal className='gx-0 mt-8'>
                <Col xs={12}>
                  <Row>
                    <Col xs={6} md={4} lg={5} className='fs-14 regular gray-900'>{totalFields.paymentReceived.label}</Col>
                    <Col xs={6} md={8} lg={7} className='fs-14 regular gray-900'>{getCurrency() + formatNumber(paymentReceived)}</Col>
                  </Row>
                </Col>
                <Col xs={12}>
                  <Row>
                    <Col xs={6} md={4} lg={5} className='fs-14 semibold gray-900'>{totalFields.balance.label}</Col>
                    <Col xs={6} md={8} lg={7} className='fs-14 semibold gray-900'>{getCurrency() + formatNumber(balance)}</Col>
                  </Row>
                </Col>
              </StyledTotal>
            </>}
          </Col>
        </Row>
      </Col>
    </Row>
  }


  return <Offcanvas
    backdrop={'static'}
    scroll={false}
    placement={'end'}
    show={show}
    onHide={() => {
      onCancel();
    }}
    enforceFocus={false}
    style={{ width: '88%' }}
  >
    <FormikContext.Provider value={formik}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className='w-100'>
          <Row className='w-100 gx-24'>
            <Col xs={true}>Billing</Col>
          </Row>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className='px-24 py-16 scrollable-container'>
        <Spin spinning={isLoadingUpdateBilling || taxRateSlice.isLoading || proformaInvoiceSlice.isLoading} wrapperClassName={'no-height'}>
          {formElements()}
        </Spin>
      </Offcanvas.Body>
      <Modal.Footer className='border-top'>{footerElements()}</Modal.Footer>
    </FormikContext.Provider>


    <SaveServiceForm
      onConfirm={async (val: any, details: any) => {
        if (details && details.length > 0) {
          let pricings = _.cloneDeep(values.pricings);

          if(pricings && pricings.length > 0){
            details.forEach((x: any) => {
              pricings[x?.index].isSaveAsGlobalService = val.isSaveAsGlobalService;
              pricings[x?.index].isSaveAsLocalService = val.isSaveAsLocalService;
            });
          }

          await setValues({
            ...values,
            pricings: pricings,
          });
  
          onSaveInvoice(pricings);
        }
      }}
    />
  </Offcanvas>
}

export default PageComponent;
